import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  entityMuestreadorAddFailure,
  entityMuestreadorAddRequest,
  entityMuestreadorAddSuccess, entityMuestreadorLoadFailure, entityMuestreadorLoadRequest, entityMuestreadorLoadSuccess
} from './entity-muestreador.actions';

import { MuestreadorService } from './entity-muestreador.service';
import { NotificationService } from '../../../core/core.module';

@Injectable()
export class MuestreadorEffects {
  // load
  loadRequestMuestreador = createEffect(() =>
    this.actions$.pipe(
      ofType(entityMuestreadorLoadRequest),
      mergeMap(() =>
        this.muestreadorService.getMuestreador().pipe(
          map((items) => entityMuestreadorLoadSuccess({ items })),
          catchError((error) => of(entityMuestreadorLoadFailure({ error })))
        )
      )
    )
  );

  // add
  addRequestMuestreador = createEffect(() =>
    this.actions$.pipe(
      ofType(entityMuestreadorAddRequest),
      switchMap((action) =>
        this.muestreadorService.addMuestreador(action.item).pipe(
          map((item) => entityMuestreadorAddSuccess({ item })),
          catchError((error) => of(entityMuestreadorAddFailure({ error })))
        )
      )
    )
  );

  addSuccessMuestreador = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityMuestreadorAddSuccess),
        tap(() => {
          this.notification.success('Solicitud de Muestreador registrado con éxito');
          return this.router.navigate(['/main', 'landing'])
        })
      ),
    { dispatch: false }
  );

  // change

  // delete

  constructor(
    private actions$: Actions,    
    private muestreadorService: MuestreadorService,
    private router: Router,
    private notification: NotificationService
  ) {
    this.muestreadorService.url = environment.apiUrl;
  }
}
